import React from 'react'
import create from 'zustand'
import { head, isArray, values } from 'lodash-es'
import useProjectStore from '../project/use-project-store'
import { useTbConfigsSWR } from '../swrs/tables/use-table-config'
import { useAppConfigSWR, useNavConfigSWR } from '../swrs/apps/use-app-config'
import { AppStoreProvider } from './app-store-provider'

const ENV = process.env.REACT_APP_DEP || 'dev'

export default function ({ children, appId, token, alwaysShowChildren, tpl }) {
  console.log({ appId })
  const dbName = `voltali_${ENV}_${appId}`
  const { getVtProject } = useProjectStore()
  const vtProject = getVtProject()
  vtProject.setApp(appId)

  // vtProject.db = { data: {} }
  // vtProject.db.data[dbName] = vtProject.db.data[dbName] || {}
  // const db = vtProject.db.data[dbName]

  // 获取app的配置信息,这个接口也获取了当前登录人的信息
  const { ProjectConfig, isAppConfigLoading } = useAppConfigSWR(appId, token)
  // 获取app的导航信息
  const { navSpec, isNavLoading } = useNavConfigSWR(appId)
  // 获取app的所有的表单信息，这个swr 优化一下
  const { tbs, tbsRaw, mutate, isTbsLoading } = useTbConfigsSWR(appId)

  if (
    !alwaysShowChildren &&
    // (models && !isCacheInited) ||
    (isAppConfigLoading || isNavLoading || isTbsLoading)
  ) {
    // 这里获取有可能失败，如果失败的话渲染错误页面吧
    // 另外这会儿其实是加载导航，表单，还有缓存，想办法并行处理
    // 这里其实可以有个加载
    return null
  }

  if (!isTbsLoading) {
    // const mtbs = mapValues(tbs || {}, (tb) => new SuperTb(tb))
    vtProject.setApp(appId, { tbs })
    // db.tbs = mtbs
    console.log(`[app-provider] ${dbName}'s tbs:`, tbs)
  }

  if (ProjectConfig && ProjectConfig.my && !vtProject.userInfoInApp) {
    vtProject.setUserInfoInApp(ProjectConfig.my)
  }

  const currentNav =
    isArray(navSpec) && head(navSpec.filter((d) => d.tpl === tpl))

  const createStore = create(() => ({
    // db: vtProject.getApp(appId).db,
    appId,
    currentNav,
    ProjectConfig: ProjectConfig && ProjectConfig.app,
    userInfoInApp: ProjectConfig && ProjectConfig.my,
    // caches: vtProject.getCachesByAppId(appId),
    navSpec,
    tbs,
    tbsRaw,
    tpl,
    // getDitto: (tbId) => vtProject.getDitto(appId, tbId),
    getDitto: (tbId, tbSlug) => {
      const obj = values(tbs).find((v) => v.tbSlug === tbSlug)
      return vtProject.getDitto(appId, tbId || (obj && obj.tbId))
    },
    updateTbs: () => mutate(),
    // getDitto,
    // dittos,
  }))

  return (
    <AppStoreProvider createStore={createStore}>{children}</AppStoreProvider>
  )
}
